import {ViewerSettingFontType} from '../../../../../../design-system/organisms/ViewerSetting/ViewerSettingFontItemType.interface';
import {TextViewerFontFamilyType} from '../type/TextViewerFontFamilyType.enum';

export function getTextViewerFontFamily(fontType: ViewerSettingFontType) {
  switch (fontType) {
    case 'Batang': {
      return `${TextViewerFontFamilyType.Batang},바탕,serif`;
    }
    case 'Myungjo': {
      return `${TextViewerFontFamilyType.Myeongjo},'나눔 명조','Nanum Myeongjo',궁서,Gungsuh,serif`;
    }
    case 'Gothic':
    default: {
      return `${TextViewerFontFamilyType.Gothic},'맑은 고딕','Malgun Gothic','Apple SD Gothic Neo',돋움,Dotum,sans-serif`;
    }
  }
}
